<template>
  <div>
    <div>
      <strong>Rates: ($1=1 scrip ticket)</strong>
    </div>
    <p>1-3 miles = $10</p>
    <p>4-5 miles = $15</p>
    <p>6-10 miles =$20</p>
    <p>Additional mile is $3</p>

    <div class="mt-10">
      <strong>Ride Rate</strong>
    </div>
    <p>Distance: {{ estimation.distance }} miles</p>
    <p>Rate: ${{ estimation.rate }}</p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'FresnoEstimation',

  props: {
    estimation: {
      type: Object,
      required: true,
    },
  },
};
</script>
